import { render, staticRenderFns } from "./teachermissioninfo.vue?vue&type=template&id=1a1331dc"
import script from "./teachermissioninfo.vue?vue&type=script&lang=js"
export * from "./teachermissioninfo.vue?vue&type=script&lang=js"
import style0 from "./teachermissioninfo.vue?vue&type=style&index=0&id=1a1331dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports